import { ElButton } from 'element-plus'

// Adicionando o tipo "myType" aos tipos permitidos do ElButton
ElButton.props.type.validator = (value) => {
  if(!value) return 1;
  return ['default', 'primary', 'success', 'warning', 'info', 'danger', 'text', 'myType', 'primario', 'secundario'].indexOf(value) !== -1
}
